import { Component } from 'react'
import { connect } from 'react-redux'
import { H1, H4, Caption, Container, Section } from '../../cdl-react-components/components'
import Link from '../../Utilities/Link'
import { updateEditions } from '../../../store/actions'
import { WEBHOST_URL } from '../../cdl-react-components/utilities/constants'
import { graphqlFetch } from '../../cdl-react-components/utilities'

class Editions extends Component {
    formatImageUrl = url => WEBHOST_URL + url.substring(url.indexOf('/public'))
    formatPdfUrl = url => WEBHOST_URL + url.substring(url.indexOf('/private'))

    renderEdition = (edition, year, key) => (
        <Link key={`editions__year__edition--${year}-${key}`} 
           href={edition.pdf ? this.formatPdfUrl(edition.pdf) : ''} 
           target="_blank" rel="noreferrer">
            <div className="editions__year__edition">
                    { edition['cover_image'] ?
                        <img alt={edition['quarter_volumn']} src={this.formatImageUrl(edition['cover_image'])} /> :
                        null }
                    <Caption>{edition['quarter_volumn']}</Caption>
            </div>
        </Link>
    )

    renderEditionYear = year => {
        const editions = this.props.editions[year];
        
        const groups = editions.reduce((acc, x, i) => { 
            const index = Math.floor(i / 2)
            acc[index] = acc[index] ?
                [...acc[index], x] :
                [x]
            return acc
        }, [])

        return (
            <div key={'editions__year--' + year}
                 className="editions__year">
                <H4>{year}</H4>
                <div className="editions__year__body">
                    { groups ?
                        groups.map((group, i) => (
                            <div className="editions__year__body__group"
                                 key={`ditions__year__body__group--${year}-${i}`}>
                                {group.map((edition, j) => this.renderEdition(edition, year, i.toString() + j))}
                            </div>
                        )) : null }
                </div>
                <hr />
            </div>
        )
    }

    render() {
        return (
            <Container id="editions">
                <Section>
                    <H1>Past Editions</H1>
                    <hr />
                    { this.props.editions ?
                        Object.keys(this.props.editions)
                            .filter(key => parseInt(key) >= 2005)
                            .sort((a, b) => b - a)
                            .map(this.renderEditionYear) :
                        null }
                </Section>
            </Container>
        )
    }

    componentDidMount() {
        if (!this.props.editions) {
            graphqlFetch('wcms3', `
                query {
                    editions {
                        id
                        title
                        year
                        publication_date: publicationDate
                        cover_image: coverImage
                        description
                        image_alt_text: imageAltText
                        pdf
                        quarter_volumn: quarterVolumn {
                            id
                            name
                        }
                    }
                }`)
                .then(res => {
                    if (res.data.editions.length === 0)
                        window.location.href = '/'
                    else {
                        const editions = 
                            res.data.editions
                                .map(edition => ({
                                    ...edition,                                              
                                    cover_image: edition.cover_image ? '/' + edition.cover_image : undefined,
                                    pdf: edition.pdf ? '/' + edition.pdf : undefined,
                                    quarter_volumn: edition.quarter_volumn?.name
                                }))

                        this.props.updateEditions(
                            editions.reduce(
                                (acc, edition) => ({ 
                                    ...acc, 
                                    [edition.year]: [...(acc[edition.year] || []), edition] 
                                }), {}))
                    }
                })
        }
    }
}

const mapStateToProps = ({data}) => ({
    editions: data.editions 
})
const mapDispatchToProps = (dispatch) => ({
    updateEditions: editions => dispatch(updateEditions(editions))
})

export default connect(mapStateToProps, mapDispatchToProps)(Editions)